import { Result } from "@cartographerio/fp";
import { isPoint, safePointToNgr, } from "@cartographerio/geometry";
import { hasKey, hasOptionalKey, isNullable, isObject, isString, } from "@cartographerio/guard";
import { isTimestamp } from "@cartographerio/types";
import { isNumber } from "lodash-es";
import { WrtWestcountryCsiFlowLevelEnum, WrtRainfallEnum, WrtWestcountryCsiWaterLevelEnum, } from "@cartographerio/inventory-enums";
export function isPartialData(data) {
    return (isObject(data) &&
        hasOptionalKey(data, "recorded", isNullable(isTimestamp)) &&
        hasKey(data, "details", (details) => isObject(details) &&
            hasOptionalKey(details, "river", isNullable(isString)) &&
            hasOptionalKey(details, "site", isNullable(isString)) &&
            hasOptionalKey(details, "location", isNullable(isPoint)) &&
            hasOptionalKey(details, "recentRain", isNullable(WrtRainfallEnum.isValue))) &&
        hasKey(data, "riverChannel", (riverChannel) => isObject(riverChannel) &&
            hasOptionalKey(riverChannel, "waterFlow", isNullable(WrtWestcountryCsiFlowLevelEnum.isValue)) &&
            hasOptionalKey(riverChannel, "waterLevel", isNullable(WrtWestcountryCsiWaterLevelEnum.isValue)) &&
            hasOptionalKey(riverChannel, "temperature", isNullable(isNumber)) &&
            hasOptionalKey(riverChannel, "totalDissolvedSolids", isNullable(isNumber)) &&
            hasOptionalKey(riverChannel, "turbidity", isNullable(isString)) &&
            hasOptionalKey(riverChannel, "phosphate", isNullable(isNumber))) &&
        hasOptionalKey(data, "notes", isNullable(isString)));
}
export function dataDescription(data) {
    return Result.guard(isPartialData, "PartialWrtWestcountryCsiData")(data).map(data => [
        data.details.river ?? "Unknown river",
        data.details.site ?? "Unknown site",
        data.details.location
            ? safePointToNgr(data.details.location)
            : "Unknown NGR",
    ].join(", "));
}
export function dataGeometry(data) {
    return Result.guard(isPartialData, "PartialWrtWestcountryCsiData")(data).map(data => data.details.location ?? null);
}
export function dataTimestamp(data) {
    return Result.guard(isPartialData, "PartialWrtWestcountryCsiData")(data).map(data => data.recorded ?? null);
}
export function copyData(data) {
    return Result.guard(isPartialData, "PartialWrtWestcountryCsiData")(data).map(data => ({
        ...data,
        recorded: null,
        details: {
            ...data.details,
            dynamicRiskAssessment: null,
            recentRain: null,
        },
        riverChannel: {
            ...data.riverChannel,
            waterFlow: null,
            waterLevel: null,
            temperature: null,
            totalDissolvedSolids: null,
            turbidity: null,
            phosphate: null,
        },
        notes: null,
    }));
}
//# sourceMappingURL=parts.js.map